import { useEffect, useState } from 'react';
import { EventScheduledEvent, PopupModal } from 'react-calendly';

import { useCalendly } from '@/hooks/useCalendly';
import { ID_CALENDLY_CONTAINER } from '@/utils/constants';

export type CalendlyModalProps = {
  opened: boolean;
  link: string;
  company?: string;
  firstName?: string;
  email?: string;
  lastName?: string;
  phone?: string;
  onClose: () => void;
  onSubmit: (e: EventScheduledEvent) => void;
};

export default function CalendlyModal(props: CalendlyModalProps) {
  const { link, onClose, onSubmit, opened, ...prefillInformation } = props;
  const { prefillCalendly, calendlyLink, utmCalendly } = useCalendly({
    link,
    onSubmit,
    ...prefillInformation,
  });
  const [rootModal, setRootModal] = useState<HTMLElement>();

  useEffect(() => {
    const root = document.getElementById(ID_CALENDLY_CONTAINER)!;

    if (opened) {
      root.classList.remove('hidden');
    } else {
      root.classList.add('hidden');
    }

    setRootModal(root);
  }, []);

  useEffect(() => {
    if (!rootModal) {
      return;
    }

    if (opened) {
      rootModal.classList.remove('hidden');
    } else {
      rootModal.classList.add('hidden');
    }
  }, [opened]);

  return (
    <>
      {rootModal && (
        <PopupModal
          url={calendlyLink}
          utm={utmCalendly}
          prefill={prefillCalendly}
          onModalClose={onClose}
          open={true}
          rootElement={rootModal!}
          pageSettings={{ hideGdprBanner: true }}
        />
      )}
    </>
  );
}
